import React from 'react'
import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Theme/Common'

export const BetCardTitle: React.FC<{
  title: string
  rightComponent?: React.ReactNode
  bottomLeftComponent?: React.ReactNode
  bottomRightComponent?: React.ReactNode
}> = ({ title, rightComponent, bottomLeftComponent, bottomRightComponent }) => {
  return (
    <WrapperStyled>
      <div>
        <span className='bet-card-title__text'>{title}</span>
        <span>{bottomLeftComponent}</span>
      </div>

      <div>
        <span className='bet-card-title__text'>{rightComponent}</span>
        {bottomRightComponent}
      </div>
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingBottom: spacing.smx1,
  borderBottom: `0.5px solid ${colors.neutral[200]}`,

  '> div': {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.2rem',

    '&:last-of-type': { alignItems: 'flex-end' },

    '> span': { display: 'flex', '&:empty': { display: 'none' } },
  },

  '.bet-card-title__text': {
    fontFamily: font.family.primary,
    fontSize: font.size.lg.fontSize,
    letterSpacing: font.size.lg.letterSpacing,
    lineHeight: font.size.lg.lineHeight,
    fontWeight: font.weight.medium,
    color: colors.black,
  },
})
